import { useEffect, useLayoutEffect } from 'react';
import { FirebaseErrorSources } from '@constants/firebase';
import { initFirebaseClient, setFirebaseConfig } from '@helpers/firebase-client';
import { reportUiError, shouldIgnoreWindowError } from '@helpers/firebase-error';
import { useCommons } from '@hooks/use-commons';
var globalHandlersRegistered = false;
function registerGlobalErrorHandlers() {
    if (globalHandlersRegistered || typeof window === 'undefined')
        return;
    globalHandlersRegistered = true;
    var onError = function (event) {
        if (shouldIgnoreWindowError(event))
            return;
        var errorName = event.error instanceof Error ? event.error.name : 'Error';
        reportUiError({
            source: FirebaseErrorSources.WINDOW_ONERROR,
            message: event.message || 'Unknown error',
            errorType: errorName,
            filename: event.filename,
            line: event.lineno,
            column: event.colno,
            stack: event.error instanceof Error ? event.error.stack : undefined
        });
    };
    var onRejection = function (event) {
        var reason = event.reason;
        var message = reason instanceof Error
            ? reason.message
            : typeof reason === 'string'
                ? reason
                : 'Unhandled rejection';
        var errorType = reason instanceof Error ? reason.name : 'Rejection';
        reportUiError({
            source: FirebaseErrorSources.UNHANDLED_REJECTION,
            message: message,
            errorType: errorType,
            stack: reason instanceof Error ? reason.stack : undefined
        });
    };
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
}
export function FirebaseProvider(_a) {
    var children = _a.children, config = _a.config;
    setFirebaseConfig(config);
    var isBotUser = useCommons().isBotUser;
    useLayoutEffect(function () {
        if (isBotUser)
            return;
        registerGlobalErrorHandlers();
    }, [isBotUser]);
    useEffect(function () {
        if (isBotUser)
            return;
        var start = function () {
            void initFirebaseClient();
        };
        if (typeof window.requestIdleCallback === 'function') {
            var idleId_1 = window.requestIdleCallback(start);
            return function () { return window.cancelIdleCallback(idleId_1); };
        }
        var timeoutId = setTimeout(start, 0);
        return function () { return clearTimeout(timeoutId); };
    }, [isBotUser]);
    return children;
}
